import React from 'react';
import '../../design-system/animations.css';

/**
 * Ambient stadium layer — gradients only; athlete triptych stays in app hero.
 */
export default function StadiumAtmosphere() {
  return (
    <div
      className="stadium-atmosphere fixed inset-0 overflow-hidden pointer-events-none z-0"
      aria-hidden
      data-testid="stadium-atmosphere"
    >
      <div className="absolute inset-0 bg-[#07090d]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(140,255,74,0.08)_0%,_transparent_58%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_rgba(51,214,255,0.06)_0%,_transparent_50%)]" />

      <div className="stadium-atmosphere__beam stadium-atmosphere__beam--left absolute -top-[18%] left-[8%] h-[72vh] w-[34vw] max-w-[280px] rounded-full bg-emerald-500/12 blur-[90px]" />
      <div className="stadium-atmosphere__beam stadium-atmosphere__beam--right absolute top-[12%] -right-[8%] h-[58vh] w-[38vw] max-w-[300px] rounded-full bg-cyan-500/10 blur-[100px]" />
      <div className="stadium-atmosphere__beam stadium-atmosphere__beam--center absolute top-[38%] left-1/2 h-[42vh] w-[48vw] max-w-[360px] -translate-x-1/2 rounded-full bg-emerald-400/6 blur-[110px]" />

      <div className="stadium-atmosphere__haze absolute inset-x-0 bottom-0 h-[38vh] bg-gradient-to-t from-black/55 via-black/15 to-transparent" />
      <div className="absolute inset-0 opacity-[0.035] bg-[linear-gradient(rgba(255,255,255,0.5)_1px,transparent_1px)] bg-[length:100%_3px]" />
    </div>
  );
}
